import createLendingBundle from './createBundle'
import whitepaper from './whitepaper.fr'
import yieldLadder from './yieldLadder.fr'

export default createLendingBundle({ whitepaper, yieldLadder })
